module.exports = "/fonts/trialProofer-iconPack.woff?96326e3743b880b0cf6dc67495e2a9b0";